export class StyleFormatter {
    /**
     * Extracts value from formatted string (e.g. 'lg-18px' -> '18px')
     */
    static extractValue(formattedString?: string): string | undefined {
        return formattedString?.split('-').pop()
    }

    /**
     * Processes media query object to extract formatted values
     */
    static processMediaQuery(mediaQuery: any) {
        if (!mediaQuery) return null

        return {
            media: this.extractValue(mediaQuery.media),
            titleFontSize: this.extractValue(mediaQuery.titleFontSize),
            titleFontWeight: this.extractValue(mediaQuery.titleFontWeight),
            titleAlignment: mediaQuery.titleAlignment,
            fontSize: this.extractValue(mediaQuery.fontSize),
            fontWeight: this.extractValue(mediaQuery.fontWeight),
            alignment: mediaQuery.alignment
        }
    }

    /**
     * Process an array of media queries
     */
    static processMediaQueries(mediaQueries?: any[]) {
        return mediaQueries?.map(mq => this.processMediaQuery(mq)) || []
    }
}
